import { render, staticRenderFns } from "./previewdoc.vue?vue&type=template&id=2bc6c75c&scoped=true"
import script from "./previewdoc.vue?vue&type=script&lang=js"
export * from "./previewdoc.vue?vue&type=script&lang=js"
import style0 from "./previewdoc.vue?vue&type=style&index=0&id=2bc6c75c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6c75c",
  null
  
)

export default component.exports